<template>
 <b-modal 
        id="modal_form"
        ref="modal_form"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        cancel-title="Cancelar"
        :ok-disabled=form.errors.any()
        v-model="showModal"
        @ok="handleOk">

         <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
             <label>Código</label>
             <b-form-input type="text"
                           placeholder="Código"
                           v-model="form.cd"
                           name="cd"
                           >
             </b-form-input>
             <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

             <label>Descrição</label>
             <b-form-input type="text"
                           placeholder="Descrição"
                           v-model="form.descr"
                           name="descr"
                           >
             </b-form-input>
             <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

             <label>Status</label>
             <multiselect v-model="statusSelected"
             :options="this.$parent.optionsLivStatus"
             track-by="value"
             label="label"
             :hide-selected="true"
             placeholder="Selecione"
             tag-placeholder="Selecionar"
             select-label="Selecionar"
             selected-label="Selecionado"
             deselect-label="Remover"
             ></multiselect>
             <b-form-feedback v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>

         </form>
                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="showModal=false" variant="secondary">
                             Fechar
                           </b-btn>
                           <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                             Enviar
                           </b-btn>
                       </div>
                </div>
            </b-modal>

</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
        data() {
            return {
                dataExport: [],
                modal_titulo: '',
                modal_botao: '',
                modal_acao: '',
                showModalNaturezaAliquota: false,
                loading: false,
                isDisabled: false,
                loadingData: true,
                showModal: false,
                isFullscreen: false,
                optionsLivStatus: [],
                statusSelected: [],
                optionsLivCfop: [],
                form: new Form({
                    cd: '',
                    descr: '',
                    cfop_id: '',
                    status: ''
                }),
                form_natureza_aliquota: new Form({
                    aliquota: '',
                    descr: '',
                    cfop_id: '',
                    cd_erp: '',
                    cfonatali_id: '',
                    tipo: '',
                    status: []
                }),
                helpForm: new Form({
                    recordCollection: [],
                    params: []
                }),
                css: {
                    loadingClass: 'loading',
                    ascendingIcon: 'glyphicon glyphicon-chevron-up',
                    descendingIcon: 'glyphicon glyphicon-chevron-down',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                },
                moreParams: {}
            }
        },
        watch: {
            statusSelected(obj){
                this.form.status = obj.value;
            },
        },
        mounted() {
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset', e => this.onFilterReset());
        },
        created() {
            let self = this;
            Event.$on('reloadVuetable', function(data) {
                self.onReloadVuetable();
            });
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            onFilterSet(data_filter) {
                this.loadingData = true;
                this.moreParams = {
                    'cd': data_filter.cd,
                    'descr': data_filter.descr,
                    'status': data_filter.status.value
                }
                Vue.nextTick(() => {
                    this.$refs.vuetable.refresh();
                })
            },
            onFilterReset() {
                this.loadingData = true;
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterShowHide() {
                if (this.vuetableFilterRow) {
                    this.$store.commit('setVuetableFilterRow', false);
                } else {
                    this.$store.commit('setVuetableFilterRow', true);
                }
            },
            onReloadVuetable() {
                this.$refs.vuetable.reload();
            },
            onLoaded: function() {
                this.dataExport = this.$refs.vuetable.tableData;
                this.loadingData = false;
                this.$store.commit('setVuetableFilterButton', false);
            },
            onDetail(data, field, event) {
                this.$refs.vuetable.toggleDetailRow(data.cfop_id);
            },
            
            handleOk(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStore();
                } else {
                    this.onUpdate(this.form.cfop_id);
                }
            },
            onCreate() {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Cadastrar";
                this.modal_botao = "Cadastrar";
                this.modal_acao = "i";
                this.form.reset();
                this.statusSelected  = [];
                this.$refs.modal_form.show();
            },
            onEdit(data, index) {
                this.isDisabled = false;
                this.loading = false;
                this.modal_titulo = "Alterar";
                this.modal_botao = "Alterar";
                this.modal_acao = "u";
                this.form.reset();
                this.form.cd = data.cd;
                this.optionsLivStatus = [];
                this.statusSelected = [];
                this.form.descr = data.descr;
                this.statusSelected = {
                    label: data.status.descr,
                    value: data.status.valor
                };
                this.form.cfop_id = data.cfop_id;
                this.$refs.modal_form.show();
            },
            onStore() {
                this.loading = true;
                this.isDisabled = true;
                this.form.put('/api/cfop/store').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onUpdate(id) {
                this.loading = true;
                this.isDisabled = true;
                this.form.patch('/api/cfop/update/' + id).then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onActivateDesactivate(helpForm)
            {
                helpForm.patch('/api/cfop/status').then(response =>
                {
                    new ReturnApi(response, this)
                    if(this.metodo!=null)
                    {
                       this.metodo();
                    }
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this, true, null, null, false);
                    this.errors_array = '';
                    this.errors_array = [];
                    for (var property in errors) {
                      if (errors.hasOwnProperty(property)) {
                        if (typeof(errors[property]) === 'object') {
                          errors[property].forEach((obj) => {
                            this.errors_array.push({
                              erro: obj
                            });
                          });
                        }
                      }
                    }
                });
            },
            onError(response) {
                new ReturnApi(response.response, this, true, true, false);
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
        },
        computed: {
            vuetableFilterRow: {
                get() {
                    return this.$store.state.vuetable.filterRow;
                },
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            }
        }
    }
</script>
